import { AntennaLight, AntennaSummary } from '@wwf/sdk';
import { Box, Typography } from '@mui/material';
import { Link, useRecordContext } from 'react-admin';
import { AntennaAvatar } from './AntennaAvatar';
import { getLinkToAntenna } from '../getLinkToAntenna';

export const AntennaLightCard = (props: {
    record?: AntennaLight | AntennaSummary;
    noLink?: boolean;
}) => {
    const record = useRecordContext<AntennaLight | AntennaSummary>(props);
    const content = (
        <Box display="flex" alignItems="center" gap={0.5}>
            <AntennaAvatar variant="sm" record={record} />
            <Typography variant="body2" noWrap>
                {record?.name}
            </Typography>
        </Box>
    );

    return props.noLink ? (
        content
    ) : (
        <Link to={getLinkToAntenna(record?.id)}>{content}</Link>
    );
};
